<template>
  <div>
    <b-modal
      size="lg"
      v-model="visible"
    >
    <template slot="modal-title">
      {{titulo}}
    </template>

      <div>
        <b-row>
          <b-col lg="12">
            <b-form>
              <b-card-body>
                <b-row>

                  <b-col sm="6">

                    <b-form-group
                      :label="crearLabel('Nombre', 'gpecodigo', 'datosFormulario')"
                      label-for="gpecodigo">
                      <b-form-input
                        id="gpecodigo"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gpecodigo"
                        :disabled="campoBloqueado('gpecodigo', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_proest', 'gpecodigo', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gpecodigo }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Descripción', 'gpedescripcion', 'datosFormulario')"
                      label-for="gpedescripcion">
                      <b-form-input
                        id="gpedescripcion"
                        type="text"
                        placeholder=""
                        v-model="datosFormulario.gpedescripcion"
                        :disabled="campoBloqueado('gpedescripcion', 'datosFormulario')"
                        @change="validarCampo('pkg_genpp_proest', 'gpedescripcion', $event, 'datosFormulario')">
                      </b-form-input>
                      <span class="error-validacion-campo">
                          {{ mensajeValidacionCampo.gpedescripcion }}
                      </span>
                    </b-form-group>

                    
                  </b-col>
                  <b-col sm="6">
                    <b-form-group
                      :label="crearLabel('Efecto', 'gpeefecto', 'datosFormulario')"
                      label-for="gpeefecto">
                      <b-form-select 
                        :options="valEfecto"
                        v-model="datosFormulario.gpeefecto"
                        :disabled="campoBloqueado('gpeefecto', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gpeefecto }}
                      </span>
                    </b-form-group>

                    <b-form-group
                      :label="crearLabel('Estado Inicial', 'gspiniestado', 'datosFormulario')"
                      label-for="gspiniestado">
                      <b-form-select 
                        :options="valEstadoInicial"
                        v-model="datosFormulario.gspiniestado"
                        :disabled="campoBloqueado('gspiniestado', 'datosFormulario')"
                        
                      >
                      </b-form-select>
                     
                      <span class="error-validacion-campo">
                        {{ mensajeValidacionCampo.gspiniestado }}
                      </span>
                    </b-form-group>
                  </b-col>

                </b-row>
              </b-card-body>
            </b-form>
          </b-col>
        </b-row>
      </div>
      <div
        slot="modal-footer"
        class="w-100"
      >
        <p class="float-left"></p>
        <b-button
          type="submit"
          variant="primary"
          class="float-right"
          style="margin-right:8px;"
          @click="guardarEstado"
        > Guardar</b-button>

        <b-button
          type="submit"
          variant="secondary"
          class="float-right"
          style="margin-right:8px;"
          @click="modalEditarEstado = false; visible = false;"
        >Cancelar</b-button>

      </div>
    </b-modal>
  
  </div>
</template>
<script>

import axios from "axios";
import apiActividades from "@/components/services/apiActividades";
import { globalesMixin } from "../../components/mixins/globalesMixin";

export default {
  name: "EditarEstado",
  mixins: [globalesMixin],
  data: function() {
    return {
      titulo: "",
      visible: false,
      modalEditarEstado: false,
      modalAgregarEstado: false,
      datosFormulario: {
        gsaproced: "",
        gpecodigo: "",
        gpedescripcion: "",
        gpeefecto: "",
        gspiniestado: "",
        desc_activo: ""
      },

      valEstadoInicial: [],
      valEfecto: [],

      datosFormularioEstado: [],
      mensajeValidacionCampo: {}
    };
  },
  methods: {
    obtenerEstado(mail, usuario, p_gsaproced, gpecodigo, tiporec) {
      this.titulo = "Editar Estado";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .buscarEstado(mail, usuario, p_gsaproced, gpecodigo, tiporec)
        .then(response => {
          
          this.datosFormulario.gsaproced = p_gsaproced;
          this.datosFormulario.gpecodigo = "";
          this.datosFormulario.gpedescripcion = "";
          this.datosFormulario.gpeefecto = "";
          
          response.data = this.keysMinuscula(response.data);
          this.datosFormulario = response.data.res[0];

          this.datosFormularioEstado = response.data.festado;


          //Carga lista de tipo estado inicial
          var tiposEstadoini = new Array();
          var lista_tipos_estado_ini = response.data.estado_ini;
          for(var i = 0; i < lista_tipos_estado_ini.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_estado_ini[i]["gspiniestado"];
              obj.text = lista_tipos_estado_ini[i]["desc_gspiniestado"];
              tiposEstadoini.push(obj);
          }
          this.valEstadoInicial = tiposEstadoini;

          //Carga lista de tipo efectos
          var tiposefectos = new Array();
          var lista_tipos_efecto = response.data.efectos;
          for(var i = 0; i < lista_tipos_efecto.length; i++){
              var obj = new Object();
              obj.value = lista_tipos_efecto[i]["gpeefecto"];
              obj.text = lista_tipos_efecto[i]["desc_efecto"];
              tiposefectos.push(obj);
          }
          this.valEfecto = tiposefectos;

          this.modalEditarEstado = true;
          this.visible = true;
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    pre_insertar(mail, usuario, p_gsaproced, gpecodigo) {
      this.titulo = "Agregar Estado";
      this.mensajeValidacionCampo = {};
      return apiActividades
        .pre_insertarEstado(mail, usuario, p_gsaproced, gpecodigo)
        .then(response => {
          response.data = this.keysMinuscula(response.data);

          this.datosFormulario.gsaproced = p_gsaproced;
          this.datosFormulario.gpecodigo = "";
          this.datosFormulario.gpedescripcion = "";
          this.datosFormulario.gpeefecto = "";
      
          this.datosFormularioEstado = response.data.festado;

          
         
          this.modalAgregarEstado = true;
          this.visible = true;

          console.log(this.datosFormulario);

        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },

    guardarEstado(event) {
      event.preventDefault();
      this.$Progress.start();
      
      
      if (this.modalEditarEstado){
        return apiActividades
        .modificarEstado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaEstados");
            this.modalEditarEstado = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }else if (this.modalAgregarEstado) {
        return apiActividades
        .insertarEstado(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.datosFormulario
        )
        .then(response => {
          this.mensajeToastr({
            title: response.data.festado.resultado.titulo,
            message: this.crearError(response.data.festado, "datosFormulario"),
            type: response.data.festado.resultado.estado,
            timeout: 6000
          });
          if (response.data.festado.resultado.estado != "error") {
            this.$emit("actualizaEstados");
            this.modalAgregarEstado = false;
            this.visible = false;
          }
          this.$Progress.finish();
        })
        .catch(error => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
      }

    }
    
  }
};
</script>
<style scoped>
</style>
